import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
import { fetchCustomer, loginCustomer, setCustomerAuth } from './customer';
const initialState = {
    loading: 'idle',
    error: null
};
export var SignUpActionType;
(function (SignUpActionType) {
    SignUpActionType["SignUpCustomer"] = "signUp/signUpCustomer";
})(SignUpActionType || (SignUpActionType = {}));
export const signUpCustomer = createAsyncThunk(SignUpActionType.SignUpCustomer, ({ data, callback }, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { api, brand } = getState().config;
        const response = yield api.postSignUp(data);
        const { email, password } = data;
        if (email && password) {
            if ((brand === null || brand === void 0 ? void 0 : brand.tpls) && (brand === null || brand === void 0 ? void 0 : brand.tpls) !== 'SPARKFLY') {
                const resp = yield api.postCustomerSignIn(data);
                dispatch(setCustomerAuth(resp));
                yield dispatch(fetchCustomer());
            }
            else {
                dispatch(loginCustomer({ email, password }));
            }
        }
        if (callback)
            callback(response);
        return;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const signUpSlice = createSlice({
    name: ReducerType.SignUp,
    initialState,
    reducers: {
        resetSignUp: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(signUpCustomer.fulfilled, () => initialState)
            .addCase(signUpCustomer.pending, state => {
            state.loading = 'pending';
        })
            .addCase(signUpCustomer.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        });
    }
});
export const { resetSignUp } = signUpSlice.actions;
export const selectSignUp = (state) => state.signUp;
export const signUpReducer = signUpSlice.reducer;
